import { BaseRoute } from "./models/base-route";

export class SharedRoutes {
    static readonly homeRoute: BaseRoute = { name: "home", route: "/home", titleName: $localize `Home` }
    static readonly reportsRoute: BaseRoute = { name: "reports", route: "/reports", titleName: $localize `Reports` }

    static readonly errorWithCodeRoute: BaseRoute = { name: "error/:code", route: "/error/:code", titleName: $localize `Error` }
    static readonly errorRoute: BaseRoute = { name: "error", route: "/error", titleName: $localize `Error` }

    static readonly apiAccessRoute: BaseRoute = { name: "api-access", route: "/api-access", titleName: $localize `API Access` }

    static readonly configurationRoute: BaseRoute = { name: "configuration", route: "/configuration", titleName: $localize `Configuration` }

    static readonly eventlogsRoute: BaseRoute = { name: "event-logs", route: "/event-logs", titleName: $localize `Event Logs` }

    static readonly allowedOriginsRoute: BaseRoute = { name: "notification-options", route: "/notification-options", titleName: $localize `Notification options` }

    static readonly entityRoute: BaseRoute = { name: "entity", route: "/entity", titleName: $localize `Entity` }
    static readonly runRoute: BaseRoute = { name: "runs", route: "/runs", titleName: $localize `Runs` }
    static readonly dqmRoute: BaseRoute = { name: "dqm", route: "/dqm", titleName: $localize `Data Quality Management` }

    static readonly settingsRoute: BaseRoute = { name: "dqm/settings", route: "/dqm/settings", titleName: $localize `Data Check Settings` }
    static readonly dataReportRoute: BaseRoute = { name: "reports/data", route: "/reports/data", titleName: $localize `Data Check Reports` }

    static readonly solverRoute: BaseRoute = { name: "solver", route: "/solver", titleName: $localize `Solver` }

    static readonly auditTrailRoute: BaseRoute = { name: "audit-trail", route: "/audit-trail", titleName: $localize `Audit Trail` }
}

export class DataCheckSettingsRoutes {
    static readonly editRoute: BaseRoute = { routeName: {_:"dqm/settings/", idParam: ":id", edit: "/edit"}, paramRoute: {_: "/dqm/settings/", idParam:":id", edit: "/edit"}, titleName: $localize `Check Edit` }
}

export class DataReportsRoutes {
    static readonly baseRoute: BaseRoute = { routeName: {_:"reports/data/", idParam: ":name"}, paramRoute: {_: "/reports/data/", idParam:":name" } }
}

export class EntityRoutes {
    static readonly entityDataRoute: BaseRoute = { name: "data", route: "/data", titleName: $localize `Data` }
}

export class ExplorerRoutes {
    static readonly explorer: BaseRoute = { name: "explorer", route: "/explorer", titleName: $localize `Explorer` }
}

export class RunRoutes {
    static readonly manualRunImportRoute: BaseRoute = { name: "manual-run-import", route: "/manual-run-import", titleName: $localize `Manual Run Import` }
    static readonly manualRunExportRoute: BaseRoute = { name: "manual-run-export", route: "/manual-run-export", titleName: $localize `Manual Run Export` }
    static readonly groupInfoRun: BaseRoute = { name: "group-info", route: "/group-info", titleName: $localize `Runs` }
    static readonly latestRunEntity: BaseRoute = { name: "entities/latest", route: "/entities/latest", titleName: $localize `Entities` }
}

export class ReportRoutes {
    static readonly workQueueRoute: BaseRoute = { name: "work-queue", route: "/work-queue", titleName: $localize `Work Queue` }
    static readonly inventoryGraphRoute: BaseRoute = { name: "inventory-graph", route: "/inventory-graph", titleName: $localize `Inventory Graph` }
    static readonly loadGraphRoute: BaseRoute = { name: "load-graph", route: "/load-graph", titleName: $localize `Load Graph` }
    static readonly operatorsRoute: BaseRoute = { name: "operators", route: "/operators", titleName: $localize `Operators` }
}

export class SolverRoutes {
    static readonly jobsRoute: BaseRoute = { name: "jobs", route: "/jobs", titleName: $localize `Jobs` }
    static readonly jobsDetailRoute: BaseRoute = { routeName: {_:"jobs/", idParam: ":id"}, paramRoute: {_: "/jobs/", idParam:":id" }, titleName: $localize `Job Detail` }
    static readonly runsRoute: BaseRoute = { name: "runs", route: "/runs", titleName: $localize `Runs` }
    static readonly inputDataSetsRoute: BaseRoute = { name: "input-data-sets", route: "/input-data-sets", titleName: $localize `Input Data Sets` }
    static readonly runsDetailRoute: BaseRoute = { routeName: {_:"runs/", idParam: ":id"}, paramRoute: {_: "/runs/", idParam:":id" }, titleName: $localize `Run Detail` }
}

export class AuditTrailRoutes {
    static readonly checksRoute: BaseRoute = { name: "checks", route: "/checks", titleName: $localize `Checks` }
    static readonly lastCheckRoute: BaseRoute = { name: "last-check", route: "/last-check", titleName: $localize `Last Check` }
    static readonly logsArchiveRoute: BaseRoute = { name: "logs-archive", route: "/logs-archive", titleName: $localize `Logs Archive` }
}